module.exports = __webpack_public_path__ + "img/logo-footer.d538fbe.png";